import React from 'react';
import { ArrowRightOutlined, ClockCircleOutlined, LockOutlined } from '@ant-design/icons';
import GmailMark from './GmailMark';
import css from './ConnectGmailStep.module.scss';

interface ConnectGmailStepProps {
  recipientEmail: string;
  onConnect: () => void;
  // 'fix' = Gmail is connected but Google's "Send email on your behalf" box
  // wasn't checked; same step, re-consent copy.
  variant?: 'connect' | 'fix';
}

const ConnectGmailStep: React.FC<ConnectGmailStepProps> = ({
  recipientEmail,
  onConnect,
  variant = 'connect',
}) => (
  <section className={css.step} aria-labelledby="connect-gmail-heading">
    <div className={css.iconWrap}>
      <GmailMark />
    </div>

    <h3 id="connect-gmail-heading" className={css.heading}>
      {variant === 'fix' ? 'One more permission to send' : 'Final step before sending'}
    </h3>

    {variant === 'fix' ? (
      <p className={css.copy}>
        Your Gmail is connected, but <strong>'Send email on your behalf'</strong> wasn't
        checked — so we can't send to <strong>{recipientEmail}</strong> yet.
      </p>
    ) : (
      <p className={css.copy}>
        We'll send to <strong>{recipientEmail}</strong> from your Gmail.
        Replies land in your inbox — not in Job Beast.
      </p>
    )}

    <button className={css.primary} onClick={onConnect}>
      {variant === 'fix' ? 'Fix permission' : 'Continue with Gmail'}
      <ArrowRightOutlined className={css.arrow} />
    </button>

    <div className={css.trust}>
      <span className={css.trustItem}>
        <ClockCircleOutlined /> 10 seconds
      </span>
      <span className={css.trustDot} aria-hidden="true">·</span>
      <span className={css.trustItem}>
        <LockOutlined /> We don't read your inbox
      </span>
    </div>
  </section>
);

export default ConnectGmailStep;
